import { Fee } from "./Fee";
import { QuoteDetail } from "./QuoteDetail";

export class Quote {
  constructor() {
    this.QuoteDetails = [];
    this.QuoteFees = [];
    this.Contact = "";
    this.QuoteNumber = "";
    this.EffectiveDate = null;
    this.ExpirationDate = null;
    this.Description = "";
    this.ProjectName = "";
    this.ShipToName = "";
    this.Status = "";
    this.TotalPrice = 0.0;
    this.DueDate = new Date();
    this.CreatedBy = "";
    this.UpdatedBy = "";
    this.ShortShipTo = "";
    this.TakenBy = "";
    this.Salesman = "";
    this.IsV2 = true;
    this.TerritoryCode = "";
    this.AE = "";
    this.QuoteRowPointer = "00000000-0000-0000-0000-000000000000";
  }

  public QuoteNumber: string;
  public CustomerNumber: string;
  public CustomerSequence: number;
  public Contact: string;
  public EffectiveDate: Date;
  public ExpirationDate: Date;
  public QuoteRowPointer: string;
  public Description: string;
  public ProjectName: string;
  public CustomerName: string;
  public ShipToName: string;
  public QuoteDetails: QuoteDetail[];
  public Status: string;
  public TotalPrice: number;
  public DueDate: Date;
  public CreatedBy: string;
  public UpdatedBy: string;
  public ShortShipTo: string;
  public QuoteFees: Fee[];
  public TakenBy: string;
  public Salesman: string;
  public IsV2: boolean;
  public TerritoryCode: string;
  public AE: string;
    
}
